import { render } from "./PostPreview.vue?vue&type=template&id=1addeadf&scoped=true"
import script from "./PostPreview.vue?vue&type=script&lang=js"
export * from "./PostPreview.vue?vue&type=script&lang=js"

import "./PostPreview.vue?vue&type=style&index=0&id=1addeadf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1addeadf"]])

export default __exports__